export const educationData = [
  {
    id: 1,
    institution: "Dr. A. P. J. Abdul Kalam Technical University, Lucknow",
    course: "B.Tech in Computer Science and Engineering",
    startYear: "2019",
    endYear: "2023",
  },
  {
    id: 2,
    institution: "Swami Harsewanand Public School",
    course: "Higher Secondary Education",
    startYear: "2017",
    endYear: "2018",
  },

  {
    id: 3,
    institution: "Swami Harsewanand Public School",
    course: "High School",
    startYear: "2015",
    endYear: "2016",
  },
];
